import { useQuery } from '@tanstack/react-query';

import { StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';
import { detectEnvironment } from '@/utils/detectEnvironment';
import { downloadJsonFileFromDatalake } from '@/utils/downloadJsonFileFromDatalake';

const useLinkBar = () => {
  const token = useStorageValue(StorageKeys.TripToken);
  const environment = detectEnvironment();

  const { data: fileContent } = useQuery({
    queryKey: [environment],
    queryFn: () =>
      downloadJsonFileFromDatalake(
        'LinkBar.json',
        `Meta_Go_Config${environment === 'staging' ? '_Staging' : ''}`
      ),
    gcTime: Infinity,
    enabled: !!token
  });

  return { linkUrl: fileContent?.url ?? '', linkMessage: fileContent?.message ?? '' };
};
export default useLinkBar;
